import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { FaxService } from 'app/fm/services/fax-service';
import { getReference } from 'app/shared/models/essette-types';
import { Toaster } from 'app/shared/lib/toaster';
import { I18N } from 'aurelia-i18n';
import * as FM from 'app/fm/models/essette-api';

@autoinject()
export class SaveFaxAccount extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.toView })
    protected faxAccount: FM.FaxAccount = {};

    protected selectedFaxQueue: FM.FaxQueue | null = null;
    protected faxQueueOptions: FM.FaxQueue[] = [];

    protected maxAccountNameLength: number = 50;
    protected maxFaxNumberLength: number = 20;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly faxService: FaxService,
        private readonly toaster: Toaster,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected async attached(): Promise<void> {
        // load lookups
        await this.reload();
    }

    ////****************** Events ***************************************************////
    protected faxAccountChanged(): void {
        this.selectedFaxQueue = null;

        if(this.faxAccount.queue) {
            const faxQueueId = this.faxAccount.queue?.id;
            this.selectedFaxQueue = this.faxQueueOptions.find(q => q.id == faxQueueId) || null;
        }
    }

    ////****************** Functions ************************************************////
    protected async reload(): Promise<void> {
        await this.loadFaxQueues();
    }

    public reset(): void {
        this.faxAccount = {};
    }

    // Construct Save Object to send over to api
    protected constructSaveObject(account: FM.FaxAccount): FM.FaxAccount {
        const saveFaxAccount: FM.FaxAccount = {
            id: account.id,
            description: account.description,
            faxNumber: account.faxNumber,
            queue: getReference(this.selectedFaxQueue)
        }

        return saveFaxAccount;
    }

    public async submit(): Promise<boolean> {
        return this.saveFaxAccount();
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    ////****************** Service Calls ********************************************////

    // Load Fax Queues for queue options avaiable to set for the fax account
    @apiCall
    private async loadFaxQueues(): Promise<void> {
        try {
            this.state.beginLoad();
            const faxQueuesResponse = await this.faxService.loadFaxQueues();
            this.faxQueueOptions = faxQueuesResponse.results;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }

    // Save Fax Account
    @apiCall
    private async saveFaxAccount(): Promise<boolean> {
        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.faxService.saveFaxAccount(this.constructSaveObject(this.faxAccount));

            isSuccessful = response.isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('fm:faxAccount.$long', isSuccessful);
            this.state.endSave();
            return isSuccessful;
        }
    }

}
